export const joannaMaciejewska = {
    'meta': {
        'title': 'Psychoterapeuta, psycholog, pedagog Joanna Maciejewska',
        'description': 'Jestem pedagogiem, psychologiem, psychoterapeutą w nurcie poznawczo-behawioralnym. Posiadam doświadczenie w pracy z młodzieżą, dorosłymi, parami i rodzinami.'
    },
    'url': {
        'address': '/bydgoszcz/zespol/psychoterapeuta-psycholog-pedagog-joanna-maciejewska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/joanna-maciejewska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychoterapeuta w Bydgoszczy Joanna Maciejewska'
        }
    }
}